module OfficeExt {
  export interface ExtendedOverridesTokenOverride {
    value: string;
    data: any;
  }
  export interface ExtendedOverridesToken {
    name: string;
    defaultValue: string;
    type: string;
    overrides: ExtendedOverridesTokenOverride[];
  }
  export interface ExtendedOverridesComputedTokens {
    [name: string]: string;
  }
}
